import { Controller } from "@hotwired/stimulus";
import { Tooltip } from "bootstrap";

// Members controller for dynamic member fields on membership forms
export default class extends Controller {
  static targets = ["container", "template", "entry"];

  add(event) {
    event.preventDefault();

    const content = this.templateTarget.innerHTML;
    const index = Date.now();
    const newEntry = content.replace(/NEW_INDEX/g, index);

    this.containerTarget.insertAdjacentHTML("beforeend", newEntry);

    const lastEntry = this.containerTarget.lastElementChild;

    // Mint a stable member_uuid for the new entry (ID-120) so it round-trips
    // through the form and pairs to the badge line/card it will create. The
    // server mints one as a fallback if this is left blank.
    const uuidInput = lastEntry.querySelector("input[data-member-uuid]");
    if (uuidInput && !uuidInput.value) uuidInput.value = crypto.randomUUID();

    lastEntry
      .querySelectorAll('[data-bs-toggle="tooltip"]')
      .forEach((el) => new Tooltip(el));
  }

  remove(event) {
    event.preventDefault();

    const entry = this.entryTargets.find((el) => el.contains(event.target));
    if (entry) {
      entry.remove();
    }
  }
}
